import React, {Component} from "react";
import "./PageBrowseSimple.css";
import {requestApiJson, requestApiRaw} from "../utils/Utils";
import {getSearchParams} from "../utils/getSearchParams";
import {ListView} from "../components/ListView";
import "bootstrap/dist/css/bootstrap.min.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import {MainContent, MainHeader} from "../components/Layout";
import {formatFileSize} from "../utils/Utils";

export class PageBrowseSimple extends Component {

    static noItems() {
        return {
            items: [],
            totalSize: 0
        };
    }

    mounted = false;

    constructor(props) {
        super(props);

        let params = getSearchParams();
        let path = params.path ? decodeURIComponent(params.path) : "/";

        this.state = {
            path: path,
            searchQuery: "",
            folders: PageBrowseSimple.noItems(),
            files: PageBrowseSimple.noItems()
        };
    }

    componentDidMount() {
        if (!this.mounted) {
            this.mounted = true;
            this.loadFolders();
            this.loadFiles();
            document.getElementById("last-item").scrollIntoView();
        }
    }

    escape = (s) => {
        return encodeURIComponent(s);
    };

    getFolderUrl = (item) => {
        return `?path=${this.escape(item.path)}`;
    };

    getResourceUrl = (item) => {
        return "/view/" + item.id;
    };

    loadFolders = () => {
        this.setState(
            s => {
                s.folders.loading = true;
                return s;
            },
            () => {
                const offset = this.state.folders.items.length;

                requestApiJson(`/view/folders?path=${encodeURIComponent(this.state.path)}&offset=${offset}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => {
                        response.items.forEach(e => e.id = e.fileName);
                        const nextItems = [...this.state.folders.items, ...response.items];

                        this.setState(state => {
                            state.folders.totalSize = response.totalSize;
                            state.folders.items = nextItems;
                            state.folders.loading = false;
                            return state;
                        });
                    })
                    .catch(e => {
                        this.setState(state => {
                            state.folders.loading = false;
                            state.folders.error = true;
                            return state;
                        });
                    });
            });
    };

    loadFiles = () => {
        if (this.state.files.loading) {
            return;
        }

        this.setState(
            s => {
                s.files.loading = true;
                return s;
            },
            () => {
                let url = `/res/folder?folder=${encodeURIComponent(this.state.path)}`;
                if (this.state.files.nextOffsetKey) {
                    url += `&offsetKey=${encodeURIComponent(this.state.files.nextOffsetKey)}`;
                }

                requestApiJson(url, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => {
                        const nextItems = [...this.state.files.items, ...response.items];

                        this.setState(state => {
                            state.files.totalSize = nextItems.length; // FIXME
                            state.files.items = nextItems;
                            state.files.loading = false;
                            state.files.nextOffsetKey = response.nextOffsetKey;
                            return state;
                        });
                    })
                    .catch(e => {
                        this.setState(state => {
                            state.files.loading = false;
                            state.files.error = true;
                            state.files.nextOffsetKey = null;
                            return state;
                        });
                    });
            });
    };

    render() {
        return <>
            <MainHeader title={this.renderPath(decodeURIComponent(this.state.path))}>
                <Navbar expand={false} data-bs-theme="dark">
                    <Container fluid>
                        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand`} className="menu-icon"/>
                        <Navbar.Offcanvas
                            aria-labelledby={`offcanvasNavbarLabel-expand`}
                            placement="end"
                        >
                            <Offcanvas.Body>
                                <Nav className="justify-content-end flex-grow-1">
                                    <Nav.Link href="/search">
                                        <img src="/img/ic-search.png" className="action-icon" alt=""/>
                                        Search
                                    </Nav.Link>
                                    <Nav.Link href={"/upload?path=" + encodeURIComponent(this.state.path)}>
                                        <img src="/img/ic-upload.png" className="action-icon" alt=""/>
                                        Upload
                                    </Nav.Link>
                                    <Nav.Link onClick={this.renameFolder}>
                                        <img src="/img/ic-move.png" className="action-icon" alt=""/>
                                        Rename folder
                                    </Nav.Link>
                                </Nav>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </Container>
                </Navbar>
            </MainHeader>
            <MainContent>
                <ListView title="Folders"
                          items={this.state.folders.items}
                          totalSize={this.state.folders.totalSize}
                          loading={this.state.folders.loading}
                          error={this.state.folders.error}
                          hasMore={this.state.folders.items.length < this.state.folders.totalSize}
                          onLoadMore={this.loadFolders}
                          renderItem={this.renderFolder}
                />
                <ListView title="Files"
                          items={this.state.files.items}
                          totalSize={this.state.files.totalSize}
                          loading={this.state.files.loading}
                          error={this.state.files.error}
                          hasMore={!!this.state.files.nextOffsetKey}
                          onLoadMore={this.loadFiles}
                          renderItem={this.renderFile}
                />
            </MainContent>
        </>;
    }

    renderFolder = (item) => {
        return <a className="item item-folder" key={item.id} href={this.getFolderUrl(item)}>
                    <div className="center"><img src="img/ic-folder.png" className="item-icon" alt=""/></div>
                    <div className="center">{item.fileName}</div>
                </a>;
    };

    renderFile = (item) => {
        return <a className="item item-file" key={item.id} href={this.getResourceUrl(item)}>
                   <div className="center">
                       {item.urlThumbnail
                            ? <img src={item.urlThumbnail} className="item-preview" alt=""/>
                            : <img src="img/ic-file.png" className="item-icon" alt=""/>}
                   </div>
                   <div>
                       <div>{item.fileName}</div>
                       <div className="muted small">{formatFileSize(item.size)}</div>
                   </div>
               </a>;
    };

    renderPath = (path) => {
        let folders = path.split("/").filter(e => e.length > 0);
        let items = [];

        items.push(<li key={-1} className="file-path-item">{folders.length > 0
            ? <a href={"/browse?path=/"}>Mindweb</a>
            : <span>Mindweb</span>}</li>);

        for (let i = 0; i < folders.length; i++) {
            let itemName = folders[i];
            let itemPath = "/" + folders.slice(0, i + 1).join("/") + "/";

            let item = i < folders.length - 1
                ? <a href={"/browse?path=" + itemPath}>{itemName}</a>
                : <span>{itemName}</span>;

            items.push(<li key={i} className="file-path-item">
                <span className="file-path-separator">/</span>
                {item}
            </li>);
        }

        return <>
            <ul className="file-path">{items}</ul>
            <div id="last-item"/>
        </>;
    };

    renameFolder = () => {
        const oldName = this.state.path;
        const newName = window.prompt("Rename folder", oldName);

        if (newName && newName !== oldName) {
            requestApiRaw('/view/folders/rename', {
                method: "POST",
                body: JSON.stringify({
                   oldName, newName
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(response => {
                    this.setState(state => {
                        state.path = newName;
                        return state;
                    });
                })
                .catch(e => {
                    console.log(e);
                });
        }
    };
}
